import React from 'react';
import { Box } from '@chakra-ui/react';
import { StaticImage } from 'gatsby-plugin-image';
import Layout from '../../components/Layout';
import PartnerCardGrid from './PartnerCardGrid';

const PARTNERS = [
  {
    name: 'AmFam',
    url: 'https://www.amfam.com/',
    image: (
      <StaticImage
        src="../../images/amfam_logo.png"
        alt="American Family Insurance logo"
      />
    ),
  },
  {
    name: 'Crawford',
    url: 'https://hover.to/blog/qa-with-ken-tolson-crawford-company/',
    image: (
      <StaticImage
        src="../../images/crawford_logo.svg"
        alt="Crawford and Company logo"
      />
    ),
  },
  {
    name: 'Fourseventy',
    url: 'http://470claims.com/blog/2020/04/03/ep-69-hovers-ceo-founder-a-j-altman/',
    image: (
      <StaticImage
        src="../../images/four_seventy_logo.svg"
        alt="Fourseventy Claims logo"
      />
    ),
  },
  {
    name: 'Hancock',
    url: 'https://www.hancockclaims.com/press-release-hover',
    image: (
      <StaticImage
        src="../../images/hancock_logo.png"
        alt="Hancock Claims logo"
      />
    ),
  },
  {
    name: 'Nationwide',
    url: 'https://news.nationwide.com/nationwide-invests-in-hover/',
    image: (
      <StaticImage
        src="../../images/nationwide_logo.svg"
        alt="Nationwide Insurance logo"
      />
    ),
  },
  {
    name: 'Pacesetter',
    url: 'https://www.adjustertv.com/posts/2020/05/28/pacesetter',
    image: (
      <StaticImage
        src="../../images/pacesetter_logo.png"
        alt="Pacesetter Claims logo"
      />
    ),
  },
  {
    name: 'StateFarm',
    url: 'https://www.statefarm.com/',
    image: (
      <StaticImage
        src="../../images/state-farm_logo.svg"
        alt="State Farm Insurance logo"
      />
    ),
  },
  {
    name: 'Travelers',
    url: 'https://www.travelers.com/',
    image: (
      <StaticImage
        src="../../images/travelers_logo.svg"
        alt="Travelers Insurance logo"
      />
    ),
  },
  {
    name: 'US Adjusting Services',
    url: 'https://www.usadjustingservices.net/',
    image: (
      <StaticImage
        src="../../images/us-adjusting-services_logo.png"
        alt="U.S. Adjusting Services logo"
      />
    ),
  },
];

const MANUFACTURERS = [
  {
    name: 'abcSeamless',
    url: 'https://abcseamless.com/abc-design-tool',
    image: (
      <StaticImage
        src="../../images/abc-seamless_logo.svg"
        alt="ABC Seamless logo"
      />
    ),
  },
  {
    name: 'Alside',
    url: 'https://www.alside.com/professionals/support-programs/alside-jobsight-3d/',
    image: <StaticImage src="../../images/alside_logo.svg" alt="Alside logo" />,
  },
  {
    name: 'Atlas',
    url: 'https://www.atlasroofing.com/',
    image: <StaticImage src="../../images/atlas_logo.png" alt="Atlas logo" />,
  },
  {
    name: 'Beacon',
    url: 'https://go.becn.com/l/269902/2019-05-31/7qgb6',
    image: <StaticImage src="../../images/beacon_logo.png" alt="Beacon logo" />,
  },
  {
    name: 'Belgard',
    url: 'https://help.hover.to/en/articles/4320999-belgard-contractor-programs-app-integration-overview',
    image: (
      <StaticImage src="../../images/belgard_logo.png" alt="Belgard logo" />
    ),
  },
  {
    name: 'CertainTeed',
    url: 'https://www.certainteed.com/HOVER/',
    image: (
      <StaticImage
        src="../../images/certainteed_logo.svg"
        alt="CertainTeed logo"
      />
    ),
  },
  {
    name: 'Drexel',
    url: 'https://www.drexmet.com/',
    image: (
      <StaticImage
        src="../../images/drexel-metals_logo.png"
        alt="Drexel Metals logo"
      />
    ),
  },
  {
    name: 'GAF',
    url: 'https://gaf.hover.to/',
    image: <StaticImage src="../../images/gaf_logo.png" alt="GAF logo" />,
  },
  {
    name: 'IKO',
    url: 'https://www.iko.com/na/roofpro-intro-page/',
    image: <StaticImage src="../../images/iko_logo.png" alt="IKO logo" />,
  },
  {
    name: 'JamesHardie',
    url: 'https://www.jameshardie.com/about-us/news/new-james-hardie-app-generates-accurate-home-measu',
    image: (
      <StaticImage
        src="../../images/james-hardie_logo.svg"
        alt="James Hardie logo"
      />
    ),
  },
  {
    name: 'KP',
    url: 'https://www.kpvinylsiding.com/',
    image: <StaticImage src="../../images/kp_logo.png" alt="KP logo" />,
  },
  {
    name: 'Lansing',
    url: 'https://lansingbp.com/',
    image: (
      <StaticImage src="../../images/lansing_logo.png" alt="Lansing logo" />
    ),
  },
  {
    name: 'LP',
    url: 'https://hover.to/blog/hover-lp-partner-bring-lp-smartside-products-exterior-contractors-via-hover-platform/',
    image: <StaticImage src="../../images/lp_logo.svg" alt="LP logo" />,
  },
  {
    name: 'Malarkey',
    url: 'https://malarkeyroofing.com/',
    image: (
      <StaticImage src="../../images/malarkey_logo.png" alt="Malarkey logo" />
    ),
  },
  {
    name: 'Norandex',
    url: 'https://www.norandex.com/products/vinyl-siding/',
    image: (
      <StaticImage src="../../images/norandex_logo.png" alt="Norandex logo" />
    ),
  },
  {
    name: 'OwensCorning',
    url: 'https://www.owenscorning.com/en-us',
    image: (
      <StaticImage
        src="../../images/owens-corning_logo.svg"
        alt="Owens Corning logo"
      />
    ),
  },
  {
    name: 'PlyGem',
    url: 'https://www.plygem.com/siding/for-siding-pros/ply-gem-hover/',
    image: <StaticImage src="../../images/plygem_logo.svg" alt="PlyGem logo" />,
  },
  {
    name: 'Royal',
    url: 'https://www.royalbuildingproducts.com/',
    image: <StaticImage src="../../images/royal_logo.png" alt="Royal logo" />,
  },
  {
    name: 'SRS',
    url: 'https://hover.to/blog/webinar-recap-hover-x-srs-distribution/',
    image: <StaticImage src="../../images/srs_logo.png" alt="SRS logo" />,
  },
  {
    name: 'Tamko',
    url: 'https://www.tamko.com/about/media-center/news-releases/post/2018/01/08/visualize-your-home-with-a-tamko-roof-on-hover',
    image: <StaticImage src="../../images/tamko_logo.png" alt="Tamko logo" />,
  },
  {
    name: 'VicWest',
    url: 'https://vicwest.com/',
    image: (
      <StaticImage src="../../images/vicwest_logo.png" alt="VicWest logo" />
    ),
  },
  {
    name: 'Wimsatt',
    url: 'https://blog.wimsattdirect.com/wimsattdirect-now-works-with-hover',
    image: (
      <StaticImage src="../../images/wimsatt_logo.png" alt="Wimsatt logo" />
    ),
  },
];

const index = () => (
  <Layout>
    {/* TODO: Remove - spacer for partial build */}
    <Box w="100%" h={60} />
    <PartnerCardGrid partnerCardItems={PARTNERS} />
    {/* TODO: Remove - spacer for partial build */}
    <Box w="100%" h={60} />
    <PartnerCardGrid partnerCardItems={MANUFACTURERS} />
  </Layout>
);

export default index;
